/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-void */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from "react";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

import SompoCard from "./SompoCard";

import SompoCardBadge from "./SompoCardBadge";

import { getCssUrl } from "../../logic/utility/thumbnailUtil";

export interface CareerCardProps {
    thumbnail?: string;
    tooltip?: string;
    height?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    badge?: string;
    children?: React.ReactNode | string;
}

const CareerCard = (props: CareerCardProps) => {
    const { thumbnail, children, badge, onClick, tooltip, height = "305px" } = props;
    const [thumbnailUrl, setThumbnailUrl] = React.useState(getCssUrl());

    React.useEffect(() => {
        setThumbnailUrl(getCssUrl(thumbnail));
    }, [thumbnail]);

    return (
        <Tooltip title={tooltip}>
            <SompoCard onClick={onClick} sx={{ height }}>
                <Box
                    sx={{
                        backgroundImage: thumbnailUrl,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        borderTopLeftRadius: "7px",
                        borderTopRightRadius: "7px",
                        aspectRatio: "16/9",
                    }}
                >
                    {badge && <SompoCardBadge division={props.badge!} />}
                </Box>
                {children}
            </SompoCard>
        </Tooltip>
    );
};

export default CareerCard;
